export const allowedProfiles = [
   "842", // FELIPE,
  "843", // ORIENTADORA DE RESPONSABILIDADES PARA LA PREVENCION,
  "844", // RINO RISK, AGENTE DE SEGUROS S.A DE C.V,
  "845", // ERNESTO,
  "846", // AHUMADA ANDRADE COMERCIALIZACION S.A DE C.V,
  "847", // IYARI CONSULTORES, S.C.,
  "848", // AGENCIA RBE SA DE CV,
  "849", // CONSULTORES DE LA TORRE VILLARREAL Y ASOCIADOS, AGENTE DE SEGUROS SA DE CV,
  "850", // CONSULTORES DE LA TORRE VILLARREAL Y ASOCIADOS, AGENTE DE SEGUROS, S.A. DE C.V.,
  "851", // PROMOTORA WIDO SA DE CV,
  "852", // ARRANO BELTZA CONSULTORES Y ASOCIADOS SC,
  "853", // ENRIQUE,
  "855", // LUZ AURORA,
  "856", // JOSE DE JESUS,
  "857", // EDGAR URIEL,
  "858", // HECTOR GABRIEL,
  "859", // MARIA PAULINA,
  "860", // FARO HORIZONTE SC,
  "861", // LATINO NEGOCIOS ESPECIALES,
  "862", // SEBASTIAN WOOLFOLK MARTINEZ,
  "863", // DAMARIS CANSECO TRUJILLO SAS DE CV,
  "864", // GRUPO ABECERRA AGENTE DE SEGUROS SA DE CV,
  "865", // ORTIZ & CANCINO S.C.,
  "866", // PROMOTORES DE LA FRONTERA SA DE CV,
  "867", // ASESORES FINANCIEROS DE VIDA Y PATRIMONIALES, AGENTE DE SEGUROS SA DE CV,
  "868", // ASEKURO AGENTE DE SEGUROS SA DE CV,
  "869", // LEBEN & HILFE AGENTE DE SEGUROS Y DE FIANZAS, SA DE CV,
  "1122", // Erick Huerta,
  "10079", // LOCKTON MEXICO, AGENTE DE SEGUROS Y DE FIANZAS, S.A. DE C.V.,
  "10840", // ABRAHAM STRINGEL VALLEJO,
  "11152", // SILVIA,
  "11433", // BERTHA ALICIA,
  "11455", // DANIELA,
  "11493", // HONORATO CARLOS HERNANDEZ BAZAN,
  "11504", // PATRICIA CRISTIANE,
  "11506", // ENRIQUE ESTEBAN,
  "11511", // JOSE ALFREDO,
  "11530", // LUIS ALBERTO,
  "11538", // MARIA JOSE,
  "11541", // JAIME MANUEL,
  "11545", // GABRIELA YICEP,
  "11547", // ZEMGO AGENTE DE SEGUROS Y DE FIANZAS SA DE CV,
  "11552", // IBETT,
  "11555", // GILDA ITZEL,
  "11557", // BERNARDO ANTONIO,
  "11561", // BLANCA JANETT,
  "11562", // ABRAHAM DANIEL,
  "11564", // SAMUEL,
  "11565", // MARCO ANTONIO,
  "11566", // ANGELICA ESPERANZA,
  "11567", // JUAN RAMON,
  "11569", // ARTURO,
  "11571", // ANDREA,
  "11572", // JESUS ANTONIO,
  "11574", // RAUL,
  "11577", // AVANZA SEGURO CONSULTORES, AGENTE DE SEGUROS Y DE FIANZAS,
  "11578", // HELEODORO MARISCAL FLORES,
  "11579", // ENRIQUE COMMESSE CHAVEZ,
  "11580", // FERNANDO,
  "11581", // PABLO,
  "11582", // DANIEL,
  "11583", // OLGA MARIA DEL CARMEN,
  "11584", // ALEJANDRO,
  "11585", // MARIA FERNANDA,
  "11586", // HILCIAS ISAAC,
  "11587", // EDGAR AMINADAB,
  "11588", // ERICK ROGELIO,
  "11590", // HUMBERTO ENRIQUE,
  "11591", // JOSE EDMUNDO,
  "11594", // SALOMON,
  "11595", // Mayra Nayeli,
  "11597", // VALERIA,
  "11598", // DULCE MARIA,
  "11599", // ROSA ISELA,
  "11600", // ERICK,
  "11602", // SERGIO,
  "11603", // MAGURABE AGENTE DE SEGUROS SA DE CV,
  "11604", // VICTOR ATALO,
  "11605", // PETRÓLEOS MEXICANOS,
  "11606", // STEPHENS AMPARAN, AGENTE DE SEGUROS SA DE CV,
  "11607", // MARIANA,
  "11609", // JOSE GUADALUPE,
  "11610", // Gobierno del Estado de Chiapas,
  "11611", // OMAR DARIO,
  "11612", // ROSA MARIA,
  "11614", // GOBIERNO DE LA CIUDAD DE MEXICO,
  "11615", // VERONICA,
  "11616", // JORGE ARTURO,
  "11617", // RICARDO,
  "11618", // EMMANUEL,
  "11619", // Francisco Rodolfo,
  "11620", // MAX FERNANDO,
  "11621", // REYDESEL,
  "11622", // GRUPO APSF AGENTE DE SEGUROS Y DE FIANZAS SA DE CV,
  "11623", // SISTEMA MUNICIPAL PARA EL DESARROLLO INTEGRAL DE LA FAMILIA DE HUIXQUILUCAN,
  "11624", // SECRETARIA DE SEGURIDAD CIUDADANA Y PROTECCION CIUDANANA,
  "11626", // GUADALUPE,
  "11627", // ENRIQUE,
  "11628", // RICARDO EDMUNDO,
  "11629", // CLAUDIA SOCORRO,
  "11630", // BERENICE,
  "11631", // MONIKA,
  "11632", // ADRIANA ALEJANDRA,
  "11633", // LIZETTE BEATRIZ,
  "11634", // ALFONSO JOSE,
  "11636", // ANDRES ALBERTO,
  "11637", // ANA CECILIA,
  "11638", // MIRIAM JANETH,
  "11639", // HUGO,
  "11640", // SAMARA ELIMAR,
  "11641", // JOEL JONATHAN,
  "11642", // JUAN ALFONSO,
  "11643", // EDITH,
  "11644", // RODRIGO,
  "11645", // VICTOR RODOLFO MARTINEZ QUIROZ,
  "11646", // DEL FARO ASESORES, AGENTE DE SEGUROS Y DE FIANZAS S.A DE C.V,
  "11647", // ESTEBAN,
  "11648", // BRENDA LIZ,
  "11649", // DIEGO ALBERTO LOPEZ CARABALLO,
  "11650", // HECTOR HIBRAIM,
  "11651", // ALVARO,
  "11652", // Adiel,
  "11653", // AGUAS DE HUIXQUILUCAN,
  "11654", // JOSE ANTONIO,
  "11655", // ROSA GUADALUPE,
  "11656", // LUIS ENRIQUE,
  "11657", // MARIA DE LA CRUZ,
  "11658", // JUAN CARLOS,
  "11660", // IGNACIO,
  "11661", // JORGE ENRIQUE,
  "11662", // RODRIGO ARTURO,
  "11663", // MELCHOR,
  "11664", // VERONICA,
  "11665", // ABRAHAM,
  "11666", // FRANCISCO ADAN,
  "11667", // ISABEL,
  "11669", // JUAN MANUEL,
  "11670", // MIGUEL ANGEL,
  "11671", // JOSE LUIS,
  "11672", // DESERY DEL ROSARIO,
  "11673", // MARIA ISABEL,
  "11674", // EDGAR,
  "11675", // MARIO ALBERTO,
  "11676", // JORGE,
  "11677", // ALEJANDRO,
  "11678", // ORLANDO,
  "11679", // SAUL,
  "11680", // JOSE ROBERTO EMMANUEL,
  "11682", // JULIETA,
  "11683", // RODRIGO,
  "11684", // DAVID,
  "11685", // LUIS IVAN,
  "11686", // MUNICIPIO DE HERMOSILLO,
  "11687", // JOSE FRANCISCO,
  "11688", // YASMIN,
  "11692", // ERICK WALDIR,
  "11693", // ROLDAN,
  "11694", // VERONICA,
  "11695", // HORTENCIA,
  "11696", // CONSULTORES DE LA TORRE VILLARREAL Y ASOCIADOS, AGENTE DE SEGUROS SA DE CV,
  "11697", // ARELI ISABEL,
  "11698", // CAROLINA,
  "11700", // JAIME ANDRES,
  "11701", // SERGIO,
  "11702", // ELIZABETH,
  "11703", // ADALBERTO,
  "11705", // EDGARDO,
  "11706", // GABRIELA,
  "11707", // MANUEL DE JESUS,
  "11708", // JORGE LUIS,
  "11709", // B INSURED AGENTE DE SEGUROS Y DE FIANZAS SA DE CV,
  "11710", // AMBAR,
  "11711", // RODRIGO EMILIANO,
  "11714", // MARIANA,
  "11716", // MARCELA,
  "11717", // ALAN PAULINO,
  "11719", // Jorge Luis,
  "11723", // ENRIQUE ANTONIO,
  "11727", // EDUARDO,
  "11728", // ANA ISABEL,
  "11729", // Juan Manuel,
  "11730", // SUEMY MARGARITA,
  "11731", // AYUNTAMIENTO DE TIJUANA,
  "11733", // JOSE ANTONIO,
  "11735", // CS RISK AGENTE DE SEGUROS Y DE FIANZAS, SA DE CV,
  "11736", // MIGUEL ANGEL,
  "11737", // RICARDO,
  "11738", // Maria del Rosario,
  "11739", // MA. EUGENIA,
  "11740", // CESAR RODOLFO,
  "11741", // Luis Saul,
  "11742", // MARIEL ANTONIA,
  "11744", // JULIO CESAR,
  "11747", // LUIS ANGEL,
  "11748", // DAVID ANDRES,
  "11749", // ANA LUISA,
  "11750", // BTECH AGENTE DE SEGUROS Y DE FIANZAS SA DE CV,
  "11751", // ALEJANDRO FRANCISCO,
  "11752", // LILIA MARGARITA,
  "11753", // DIRECTA GENERANDO,
  "11754", // RODOLFO PEDRO,
  "11755", // JOEL ARTURO,
  "11756", // ADRIAN,
  "11757", // MARIGEL,
  "11758", // JORGE LUIS,
  "11759", // MARIA GUADALUPE,
  "11760", // MARITERE PAOLA,
  "11761", // VANESSA,
  "11762", // JOSE ALFREDO,
  "11763", // ANA CRISTINA,
  "11764", // ANGEL,
  "11765", // DAFNE,
  "11766", // JUAN RICARDO,
  "11768", // Jose Luis,
  "11769", // Anahel,
  "11771", // GUILLERMO SAIDD,
  "11772", // FRANCISCO JAVIER,
  "11774", // GONTRAN GERARDO,
  "11776", // DANIEL,
  "11777", // ARMANDO,
  "11780", // OPDM-TLANEPANTLA,
  "11782", // Eva,
  "11783", // JORGE,
  "11784", // Milagros,
  "11785", // JOSE DANIEL,
  "11787", // LUIS ARMANDO,
  "11789", // Adolfo,
  "11790", // CLAUDIA GABRIELA,
  "11791", // EDGAR URIEL,
  "11792", // ROCIO,
  "11793", // CLAUDIA MARCELA,
  "11795", // MARIA,
  "11797", // ALEJANDRA DEL SOL,
  "11798", // VALERIA,
  "11799", // BLANCA GENOVEVA CARRILLO GONZALEZ,
  "11800", // ESTEFANIA GISSEL SALAZAR MENDIETA,
  "11801", // LUIS MEDINA AGUILAR,
  "11802", // CESAR ENRIQUE AVILA ONTIVEROS,
  "11803", // MIRIAM GOMEZ ESPINOZA DE LOS MONTEROS,
  "11804", // VERONICA PLAZA RODRIGUEZ,
  "11805", // FRANCISCO JAVIER ARANDA JUAREZ,
  "11806", // JESUS ROBERTO TARIN MELENDEZ,
  "11807", // ENEIDA ALMAZAN ALMAZAN,
  "11808", // ADRIANA PANTOJA GOMEZ,
  "11809", // NALLELY ABRIL JAIME CHAVEZ,
  "11810", // JOSE ANGEL SERAFIN HERNANDEZ,
  "11811", // MARGARITA VIRIDIANA HABANA DOMINGUEZ,
  "11812", // SANDRA SANCHEZ CANTU,
  "11813", // MUNICIPIO DE OTZOLOTEPEC,
  "11814", // SERVICIOS DE SALUD DE NAYARIT,
  "11815", // HECTOR MIGUEL MONROY PADILLA,
  "11816", // ANA LILIA SALDAÑA SANCHEZ,
  "11817", // DAVID ALEJANDRO GUERRA TREVIÑO,
  "11818", // MAURICIO ALBERTO MALDONADO ARANZABAL,
  "11819", // MONICA,
  "11820", // ZULEMA NAHLE MARTINEZ,
  "11821", // BRENDA MARIA ESPINOZA RUIZ,
  "11822", // Veronica Davila Uribe,
  "11823", // DANIEL ALEJANDRO ALVAREZ CUEVAS,
  "11824", // Yesika Robles Ramos,
  "11825", // DAYANA YOSIMAR QUINTERO GUERRERO,
  "11826", // MARIAFERNANDA GRACIELA TIJERINA GARCÍA,
  "11827", // ROSA ELENA DE LA CRUZ SANCHEZ RICO,
  "11828", // MACOOLEY BROKERS AGENTE DE SEGUROS S.A. DE C.V,
  "11829", // LATINOAMERICANA PLATA,
  "11830", // ALEJANDRA AHUMADA BERMUDEZ,
  "11831", // JORDAN ARTURO SAENZ LAZCANO,
  "11832", // ALDO AUGUSTO GUTIERREZ ESCOBEDO,
  "11833", // ANGELICA MARIA HERMOSILLO GOMEZ,
  "11834", // ALVAINDA GARCIA HOLGUIN,
  "11835", // "ANA KARINA FIMBRES GOMEZ	",
  "11836", // MARIA ALEJANDRA CAMACHO,
  "11837", // ALVARO GERARDO REYES BETANCOURT,
  "11838", // FIDEL LARA CASTILLO,
  "11839", // CERTUS  AGENTE DE SEGUROS Y DE FIANZAS  S.A. DE C.V.,
  "11840", // BEATRIZ ANAI NUÑEZ ESCUDERO,
  "11841", // VICTOR ELIEZER VALLEJO BAUTISTA,
  "11842", // IMELDA RAMIREZ CARRASCO,
  "11843", // LIDIETTE ELENA ULATE RUIZ,
  "11844", // ELSA GEORGINA GRIJALVA PATIÑO,
  "11845", // JUAN ARTURO NAVARRO BECERRA,
  "11846", // SOCORRO ISABEL RODRIGUEZ TREJO,
  "11847", // SELENE IVET CASTAÑON MUÑIZ,
  "11848", // JORGE ANTONIO ALMANZA AGUIRRE,
  "11849", // Nancy Hernández Acevedo,
  "11850", // AIRAM CELINA GARCIA SOLIS,
  "11851", // MARIA DE LOS ANGELES ALVARADO VARELA,
  "11852", // FLOR ELENA SOTO ZAMORANO,
  "11853", // NORMA YOLANDA HERNANDEZ RIVERA,
  "11854", // MARTHA ANGELICA DOMINGUEZ JARAMILLO,
  "11855", // NORMA LETICIA GURROLA HERNANDEZ,
  "11856", // MARTIN FRANCISCO DELGADO BUENOS AIRES,
  "11857", // SANDRO SALVATORE COTERO MORENO,
  "11858", // DANIEL ALBERTO MASCORRO SANDOVAL,
  "11859", // MARIA TERESA QUINTERO LLAUSAS,
  "11860", // Lucila Cepeda De la Torre,
  "11861", // LUIS HOMERO GUTIERREZ BUSTILLOS,
  "11862", // PAMELA MARTINEZ GONZALEZ,
  "11863", // YMG AGENTE DE SEGUROS SA DE CV,
  "11864", // EMILIO DE JESUS FUENTES FLORES,
  "77112", // USUARIO PROTSEGURA UNO,
  "77303", // Punto de Venta3 EDA  MEXI,
  "77304", // Punto de Venta4 EDA  MEXI,
  "77305", // Punto de Venta5 EDA  MEXI,
  "77306", // Punto de Venta6 EDA  MEXI,
  "77321", // FRANCISCO PASCUAL MORALES TINOCO,
  "77322", // GABRIELA HERMAN CAMPOS,
  "77323", // JESUS RICARDO LOPEZ RANGEL,
  "77324", // CARLOS HUMBERTO TORRES TINOCO,
  "77326", // TALIA FERNANDA LOMAS BEJARANO,
  "77327", // JESSICA JUDITH RABAGO DOMINGUEZ,
  "77328", // OSCAR RICARDO DE LA TRINIDAD,
  "77329", // ADRIAN RIVERA SOLANO,
  "77330", // OSIRIS GUADALUPE DIAZ LEON,
  "77331", // DIANA BALDERRAMA BALBUENA,
  "77333", // JOSE ALFREDO CASTRO MONTOYA,
  "77334", // EDITH HERNANDEZ FREGOZO,
  "77336", // FERNANDO RAMIREZ BENITEZ,
  "77337", // YURI DIANA HERMAN CAMPOS,
  "77338", // CAROLINA CASTRO MARTINEZ,
  "77339", // MIREYA DEL REAL BRAVO,
  "77340", // MARIBEL GODINEZ GARCIA,
  "77341", // USUARIO UNO,
  "77343", // MARGARITA HURTADO AUXILIAR,
  "77344", // PATRICIA SUNEM URZUA MORALES,
  "77345", // USUARIO PORTAL SERVICIOS,
  "77346", // USUARIO GSI UNO,
  "77347", // USUARIO GSI DOS,
  "77348", // USUARIO DOS,
  "77349", // USUARIO TRES,
  "77350", // USUARIO GSI TRES,
  "77351", // USUARIO GSI CUATRO,
  "77352", // USUARIO GSI CINCO,
  "77353", // USUARIO GSI SEIS,
  "77354", // USUARIO GSI SIETE,
  "77355", // USUARIO UNO MOCHIS,
  "77356", // USUARIO DOS MOCHIS,
  "77357", // USUARIO TRES MOCHIS,
  "77358", // USUARIO CUATRO MOCHIS,
  "77359", // USUARIO CINCO MOCHIS,
  "77360", // USUARIO SEIS MOCHIS,
  "77361", // USUARIO UNO CULIACAN,
  "77362", // USUARIO DOS CULIACAN,
  "77363", // USUARIO TRES CULIACAN,
  "77364", // USUARIO CUATRO CULIACAN,
  "77365", // USUARIO CINCO CULIACAN,
  "77366", // USUARIO SEIS CULIACAN,
  "77367", // USUARIO SIETE CULIACAN,
  "77368", // USUARIO UNO MAZATLAN,
  "77369", // USUARIO DOS MAZATLAN,
  "77370", // USUARIO UNO GUASAVE,
  "77371", // USUARIO DOS GUASAVE,
  "77372", // USUARIO UNO FUERTE,
  "77373", // USUARIO UNO NOVALATO,
  "77374", // USUARIO UNO DE LA CRUZ,
  "77375", // USUARIO UNO SAN IGNACIO,
  "77376", // USUARIO UNO SINALOA,
  "77377", // USUARIO UNO MOCHICAHUI,
  "77378", // ANA CAROLINA VALADEZ LOMAS,
  "77379", // CÉSAR GUSTAVO MORA GAYTÁN,
  "77380", // MARTHA ELENA CASTELO CASILLAS,
  "77381", // JOSE RAMON CASTELO CASILLAS,
  "77382", // USUARIO 1 AFIRMA,
  "77383", // USUARIO GSI OCHO,
  "77384", // USUARIO GSI NUEVE,
  "77385", // USUARIO GSI DIEZ,
  "77386", // USUARIO GSI ONCE,
  "77387", // USUARIO GSI DOCE,
  "77388", // USUARIO GSI TRECE,
  "77389", // USUARIO GSI CATORCE,
  "77390", // USUARIO GSI QUINCE,
  "77391", // USUARIO GSI DIECISEIS,
  "77392", // USUARIO GSI DIECISIETE,
  "77393", // USUARIO GSI DIECIOCHO,
  "77394", // USUARIO GSI DIECINUEVE,
  "77395", // USUARIO GSI VEINTE,
  "77396", // USUARIO GSI VEINTIUNO,
  "77397", // USUARIO GSI VEINTIDOS,
  "77398", // PUNTO VENTA AEROPUERTO,
  "77399", // USUARIO PRUEBAS CHIHUAHUA,
  "77400", // USUARIO UNO JORGE AGUILA,
  "77401", // USUARIO UNO HONEMI MANZANO,
  "77402", // USUARIO VERA MIRELES,
  "77403", // USUARIO SALT MIRELES,
  "77404", // ADRIANA GABRIELA ROMAN OCHOA,
  "77405", // SUSANA BATISTA MANRIQUEZ,
  "77406", // USUARIO GSI VEINTITRES,
  "77407", // USUARIO GSI VEINTICUATRO,
  "77408", // USUARIO GSI PUNTO VENTA 55,
  "77409", // USUARIO UNO SONORA,
  "77410", // USUARIO DOS SONORA,
  "77411", // USUARIO TRES SONORA,
  "77412", // USUARIO TABASCO TORRES MIRELES,
  "77413", // USUARIO CHIAPAS GSI,
  "77414", // ROCIO TINOCO GONZALEZ,
  "77415", // MAIRA ALEJANDRA GIL GARCIA,
  "77416", // USUARIO PUEBLA GSI,
  "77417", // USUARIO CHIAPAS 2 GSI,
  "77418", // USUARIO PUEBLA 2 GSI,
  "77419", // USUARIO SAN CRISTOBAL,
  "77420", // CESAR GONZALEZ,
  "77421", // USUARIO TAPACHULA,
  "77422", // USUARIO VERACRUZ PV31,
  "77423", // USUARIO CAMPECHE PV23,
  "77424", // ADRIANA GABRIELA ROMAN OCHOA,
  "77425", // PAOLA DAMARIS HIGUERA SOLIS,
  "77426", // ADMON MISAEL CAZARES,
  "77427", // USUARIO TRIGARANTE UNO,
  "77428", // USUARIO TRIGARANTE DOS,
  "77429", // USUARIO TRIGARANTE TRES,
  "77430", // USUARIO TRIGARANTE CUATRO,
  "77431", // USUARIO TRIGARANTE CINCO,
  "77432", // USUARIO CANCUN TORRES MIRELES,
  "77433", // USUARIO GSI TORREON 16,
  "77434", // USUARIO TUXTLA,
  "77435", // USUARIO UNO ASESORES GENERALES,
  "77436", // USUARIO UNO EXPERTA,
  "77437", // USUARIO UNO NAYARIT,
  "77438", // USUARIO DOS NAYARIT,
  "77439", // USUARIO TRES NAYARIT,
  "77440", // USUARIO CINCO NAYARIT,
  "77441", // USUARIO SEIS NAYARIT,
  "77442", // USUARIO SIETE NAYARIT,
  "77443", // USUARIO OCHO NAYARIT,
  "77444", // USUARIO NUEVE NAYARIT,
  "77445", // USUARIO DIEZ NAYARIT,
  "77446", // USUARIO CUATRO NAYARIT,
  "77447", // USUARIO GSI SINALOA,
  "77448", // USUARIO GSI VEINTICINCO,
  "77449", // USUARIO GSI VEINTISEIS,
  "77450", // USUARIO GSI VEINTISIETE,
  "77451", // USUARIO GSI VEINTIOCHO,
  "77452", // USUARIO GSI VEINTINUEVE,
  "77453", // USUARIO GSI TREINTA,
  "77454", // USUARIO GSI TREINTA Y UNO,
  "77455", // USUARIO GSI TREINTA Y DOS,
  "77456", // USUARIO GSI TREINTA Y TRES,
  "77457", // USUARIO GSI TREINTA Y CUATRO,
  "77458", // USUARIO GSI TREINTA Y CINCO,
  "77459", // USUARIO GSI TREINTA Y SEIS,
  "77462", // USUARIO UNO JJIMENEZ,
  "77463", // USUARIO JULIAN RUIZ,
  "77464", // LAURA PATRICIA GARZA CARRION,
  "77465", // CECILIA RAMIREZ REYES,
  "77466", // CECILIA VILLANUEVA LOPEZ,
  "77467", // VENTAS HYUNDAI,
  "77468", // USUARIO GSI TREINTA Y SIETE,
  "77469", // USUARIO GSI TREINTA Y OCHO,
  "77470", // USUARIO GSI TREINTA Y NUEVE,
  "77471", // USUARIO GSI CUARENTA,
  "77472", // USUARIO GSI CUARENTA Y UNO,
  "77473", // USUARIO GSI CUARENTA Y DOS,
  "77474", // USUARIO GSI CUARENTA Y TRES,
  "77475", // USUARIO GSI CUARENTA Y CUATRO,
  "77476", // USUARIO GSI CUARENTA Y CINCO,
  "77477", // USUARIO GSI CUARENTA Y SEIS,
  "77478", // USUARIO GSI CUARENTA Y SIETE,
  "77479", // USUARIO GSI CUARENTA Y OCHO,
  "77480", // USUARIO GSI CUARENTA Y NUEVE,
  "77481", // USUARIO GSI CINCUENTA,
  "77482", // USUARIO GSI CINCUENTA Y UNO,
  "77483", // USUARIO GSI CINCUENTA Y DOS,
  "77484", // USUARIO GSI CINCUENTA Y TRES,
  "77485", // USUARIO GSI CINCUENTA Y CUATRO,
  "77486", // USUARIO GSI CINCUENTA Y CINCO,
  "77487", // USUARIO GSI CINCUENTA Y SEIS,
  "77488", // USUARIO AUTO Y VARO,
  "77489", // OSBALDO BARAJAS MARTINEZ,
  "77490", // USUARIO UNO M&A,
  "77491", // MARTHA ANGELICA CONTRERAS JUAREZ,
  "77492", // KATHIAN ROXANA VALENZUELA LOPEZ,
  "77493", // CLARA VELASCOS PALACIOS,
  "77494", // USUARIO UNO GOSEGUROS,
  "77495", // USUARIO DOS M&A,
  "77496", // USUARIO UNO ALEJANDRO ROCHA,
  "77497", // USUARIO UNO MERIDA,
  "77498", // USUARIO UNO MOTOS,
  "77499", // USUARIO UNO EFECTIVO,
  "77551", // USUARIO DOS AUTO Y VARO,
  "77552", // USUARIO UNO AGUSTIN RAMIREZ,
  "77553", // USUARIO UNO JUAN GARNICA,
  "77554", // USUARIO DOS JUAN GARNICA,
  "77555", // USUARIO UNO MARGARITA HERNANDEZ,
  "77556", // USUARIO UNO BLANCA MIRELES,
  "77557", // USUARIO GSI CINCUENTA Y SIETE,
  "77558", // USUARIO GSI CINCUENTA Y OCHO,
  "77559", // USUARIO GSI CINCUENTA Y NUEVE,
  "77560", // USUARIO GSI SESENTA,
  "77561", // USUARIO GSI SESENTA Y UNO,
  "77562", // USUARIO GSI SESENTA Y DOS,
  "77563", // USUARIO GSI SESENTA Y TRES,
  "77564", // USUARIO GSI SESENTA Y CUATRO,
  "77565", // USUARIO GSI SESENTA Y CINCO,
  "77566", // USUARIO GSI SESENTA Y SEIS,
  "77567", // USUARIO UNO AURI YAMILY,
  "77568", // USUARIO GSI SESENTA Y SIETE,
  "77569", // USUARIO GSI SESENTA Y SIETE,
  "77570", // USUARIO UNO ALEJANDRO FLORES,
  "77571", // USUARIO UNO OMAR CARMONA,
  "77572", // USUARIO UNO JORGE PIMENTEL,
  "77573", // USUARIO DOS BLANCA MIRELES,
  "77574", // USUARIO UNO HECTOR VALDIVIA,
  "77575", // USUARIO DOS HECTOR VALDIVIA,
  "77576", // USUARIO TRES HECTOR VALDIVIA,
  "77577", // USUARIO CUATRO HECTOR VALDIVIA,
  "77578", // USUARIO CINCO HECTOR VALDIVIA,
  "77579", // USUARIO TRES BLANCA MIRELES,
  "77580", // USUARIO DOS OMAR CARMONA,
  "77581", // CARLOS TORRES TINOCO,
  "77582", // RAUL MATUS ARZAVE,
  "77583", // NATALLY MARTINEZ LEDEZMA,
  "77584", // YANETH GUERRERO SANCHEZ,
  "77585", // Maritza Diaz Bojorquez,
  "77586", // ALFREDO GARCIA GARCIA,
  "77587", // SANDY ANGULO,
  "77588", // PAULINA HERNANDEZ,
  "77589", // GERMAN CORTEZ,
  "77590", // FERNANDO MARTINEZ,
  "77591", // ZAIRA PATRICIA BARCELO RODRIGUEZ,
  "77592", // JESUS GONZALO ROBLES CURIEL,
  "77593", // Yaopol UNO,
  "77594", // Silva UNO,
  "77595", // Liborio 95,
  "77596", // VENTAS HYUNDAI,
  "77597", // Usuario AFernandez,
  "77598", // Usuario Senon 01,
  "77599", // Hector Jimenez,
  "77600", // Dra. Martha Martinez Robles,
  "77601", // Beatriz Flores Glz,
  "77602", // Claudia Peschard,
  "77603", // Alejandra Muzlera,
  "77604", // usuario de prueba,
  "77605", // Julian 1,
  "77707", // Oficina Xola,
  "77708", // Oficina Ayutla,
  "77709", // Usuario Pedro 1,
  "77710", // Usuario Pedro 2,
  "77711", // Usuario Pedro 3,
  "77712", // Usuario Pedro 4,
  "77713", // Usuario Pedro 5,
  "77714", // Usuario 7312 Mérida,
  "77715", // TYC JURÍDICO,
  "77716", // Angel 8809,
  "77717", // Saúl 1 Tol,
  "77718", // Saúl 2 Tol,
  "77719", // Saúl 3 Tol,
  "77720", // Saúl 1 Ixt,
  "77721", // Usuario 7312Ver1,
  "77722", // Trigarante 01,
  "77723", // Trigarante 02,
  "77724", // Trigarante 03,
  "77725", // Trigarante 04,
  "77726", // Trigarante 05,
  "77727", // 7628Octa,
  "77728", // 6752 CDMX,
  "77729", // 6752 QUIN,
  "77730", // 6752 MERIDA,
  "77731", // Reina Pool 2,
  "77732", // Reina Pool 2,
  "77734", // Cynthia Garza 1,
  "78137", // ELON AGENTE 1,
  "78140", // Mireles 1,
  "78145", // Mireles 02,
  "78146", // ISIIX 01,
  "78147", // ISIIX 02,
  "78154", // Gac 01,
  "78158", // ROSA NELLY 01,
  "78159", // Gac 02,
  "78174", // ChiapEdtih,
  "78178", // PROTEC, AGENTE DE SEGUROS Y DE FIANZAS SAPI DE CV (CD. JUAREZ),
  "78179", // PROTEC, AGENTE DE SEGUROS Y DE FIANZAS SAPI DE CV (VALLE),
  "78180", // ChiaPROTEC, AGENTE DE SEGUROS Y DE FIANZAS SAPI DE CV (MATAMOROS)pEdtih,
  "78181", // PROTEC, AGENTE DE SEGUROS Y DE FIANZAS SAPI DE CV (MONTERREY),
  "78182", // PROTEC, AGENTE DE SEGUROS Y DE FIANZAS SAPI DE CV (TIJUANA),
  "78183", // PROTEC, AGENTE DE SEGUROS Y DE FIANZAS SAPI DE CV (BOSQUES),
  "78184", // PROTEC, AGENTE DE SEGUROS Y DE FIANZAS SAPI DE CV (TORREÓN),
  "78187", // Reyes1,
  "78192", // Gaby,
  "78193", // Edgar 1,
  "78194", // YAOPOL 02,
  "78213", // SAN CRISTOBAL,
  "78214", // TAPACHULA,
  "78215", // TUXTLA,
  "78216", // SENON 01,
  "78227", // Juan Puebla,
  "78233", // Rogelio 1,
  "78234", // Rogelio 2,
  "78239", // RAUL MATUS ARZAVE,
  "78240", // CARLOS TORRES TINOCO,
  "78241", // RUBEN URBINA,
  "78242", // EDUARDO AGUILAR ARAUJO,
  "78243", // JOSE CARLOS MORENO MALDONADO,
  "78244", // GERARDO RIVERA REYES,
  "78245", // FAUSTO ESTRADA VALENCIA,
  "78246", // ELIZABETH LOPEZ ZAVALA,
  "78247", // FILIBERTO HERNANDEZ CESEÑA,
  "78248", // DIANA KAREN RASCON RODRIGUEZ,
  "78249", // ALFREDO GARCIA GARCIA,
  "78250", // JAVIER AGUILAR NUÑEZ,
  "78251", // DANIEL CORONA NAVARRO,
  "78252", // JUAN MANUEL LOPEZ CONTRERAS,
  "78253", // PERLA ISAMAR BUENO GALAVIZ,
  "78255", // NEREYDA GUTIERREZ CASTRO,
  "78256", // FLOR APARICIO ZARATE,
  "78257", // JOSE ANTONIO VIVEROS CRUZ,
  "78258", // DIANA YANIRA RODRIGUEZ VILLALPANDO,
  "78259", // KARINA FELIX RAMOS,
  "78260", // FRANCISCO PASCUAL MORALES TINOCO,
  "78261", // GABRIELA HERMAN CAMPOS,
  "78262", // OSIRIS GUADALUPE DIAZ LEON,
  "78263", // JOSE ALFREDO CASTRO MONTOYA,
  "78264", // EDITH HERNANDEZ FREGOZO,
  "78265", // YURI DIANA HERMAN CAMPOS,
  "78266", // MARIBEL GODINEZ GARCIA,
  "78267", // MARTHA ELENA CASTELO CASILLAS,
  "78268", // JOSE RAMON CASTELO CASILLAS,
  "78269", // ROCIO TINOCO GONZALEZ,
  "78270", // MAIRA ALEJANDRA GIL GARCIA,
  "78271", // OSBALDO BARAJAS MARTINEZ,
  "78272", // RAUL MATUS ARZAVE,
  "78273", // CARLOS TORRES TINOCO,
  "78274", // RUBEN URBINA,
  "78275", // EDUARDO AGUILAR ARAUJO,
  "78276", // JOSE CARLOS MORENO MALDONADO,
  "78277", // GERARDO RIVERA REYES,
  "78278", // FAUSTO ESTRADA VALENCIA,
  "78279", // ELIZABETH LOPEZ ZAVALA,
  "78280", // FILIBERTO HERNANDEZ CESEÑA,
  "78281", // DIANA KAREN RASCON RODRIGUEZ,
  "78282", // ALFREDO GARCIA GARCIA,
  "78283", // JAVIER AGUILAR NUÑEZ,
  "78284", // DANIEL CORONA NAVARRO,
  "78285", // JUAN MANUEL LOPEZ CONTRERAS,
  "78286", // PERLA ISAMAR BUENO GALAVIZ,
  "78288", // NEREYDA GUTIERREZ CASTRO,
  "78289", // FLOR APARICIO ZARATE,
  "78290", // JOSE ANTONIO VIVEROS CRUZ,
  "78291", // DIANA YANIRA RODRIGUEZ VILLALPANDO,
  "78292", // KARINA FELIX RAMOS,
  "78295", // Daniel1,
  "78296", // 6944 uno,
  "78297", // 6944 dos,
  "78298", // 6944 TRES,
  "78317", // 6944 TRES,
  "78320", // Daniel 01,
  "78321", // Gestión de Negocios,
  "78322", // Alejandra  Herman,
  "78327", // Alejandro Campos 01,
  "78328", // Gonzalo Robles 77,
  "78329", // Cynthia Medina 77,
  "78330", // Jorge Fuentes 77,
  "78331", // Jorge Fuentes 81,
  "78332", // Cynthia Medina 81,
  "78333", // Gonzalo Robles 81,
  "78335", // MIRELES 01,
  "78337", // siris Guadalupe Diaz Silvestre,
  "78338", // Maira Alejandra Gil Garcia,
  "78339", // Osiris Guadalupe Diaz Silvestre,
  "78341", // Daniel 02,
  "78350", // Blanca 01,
  "78351", // Marco 01,
  "78353", // MONTEJANO 01,
  "78354", // Felipe 02,
  "78355", // Rosa 02,
  "78360", // Gerardo Esc1,
  "78361", // Alpe 01,
  "78362", // Nora 01,
  "78363", // AUREO 01,
  "78385", // LOPEZ SEGURA 2,
  "78390", // AUREO 02,
  "78392", // FRANCISCO PASCUAL MORALES TINOCO,
  "78393", // OSIRIS GUADALUPE DIAZ LEON,
  "78394", // EDITH HERNANDEZ FREGOZO,
  "78395", // MARIBEL GODINEZ GARCIA,
  "78396", // MARTHA ELENA CASTELO CASILLAS,
  "78397", // JOSE RAMON CASTELO CASILLAS,
  "78398", // ROCIO TINOCO GONZALEZ,
  "78399", // OSBALDO BARAJAS MARTINEZ,
  "78400", // CARLOS TORRES TINOCO,
  "78401", // EDUARDO AGUILAR ARAUJO,
  "78402", // JOSE CARLOS MORENO MALDONADO,
  "78403", // FILIBERTO HERNANDEZ CESEÑA,
  "78404", // ALFREDO GARCIA GARCIA,
  "78405", // CLAUDIA GUADALUPE PEREZ VILLA,
  "78406", // NEREYDA GUTIERREZ CASTRO,
  "78407", // FLOR APARICIO ZARATE,
  "78408", // JOSE ANTONIO VIVEROS CRUZ,
  "78409", // DIANA YANIRA RODRIGUEZ VILLALPANDO,
  "78410", // JORGE FUENTES ZAVALA,
  "78411", // CYNTHIA SUZETTE MEDINA FLORES,
  "78412", // CAROLINA ZAMANO SARABIA,
  "78413", // ROCIO BARRAZA PINEDA,
  "78414", // BALLESTEROS 01,
  "78415", // BESSON 01,
  "78416", // LOPEZ SEGURA 3,
  "79022", // LUIS TORRE 2,
  "79025", // OCTAVIO 01,
  "79124", // YAOPOL 01,
  "79137", // LOPEZ CELAYA,
  "79138", // LOPEZ QUERETARO,
  "79142", // Uceda 01,
  "79147", // AMARAL 01,
  "79148", // Jimenez01,
  "79149", // Novelo01,
  "79150", // Arreola01,
  "79151", // Brana01,
  "79153", // Manuel 01,
  "79159", // MACOO1,
  "79160", // OMAR UNO,
  "79167", // Guevara 01,
  "79168", // AMBROSI 01,
  "79169", // AMBROSI 02,
  "79170", // AMBROSI 03,
  "79171", // AMBROSI 04,
  "79172", // AMBROSI 05,
  "79173", // AMBROSI 06,
  "79174", // AMBROSI 0,
  "79175", // AMBROSI 08,
  "79176", // AMBROSI 09,
  "79177", // AMBROSI 10,
  "79178", // AMBROSI 11,
  "79179", // AMBROSI 12,
  "79180", // AMBROSI 13,
  "79181", // AMBROSI 14,
  "79182", // AMBROSI 15,
  "79183", // AMBROSI 16,
  "79184", // AMBROSI 17,
  "79185", // AMBROSI 18,
  "79186", // AMBROSI 19,
  "79187", // AMBROSI 20,
  "79188", // AMBROSI 21,
  "79189", // AMBROSI 22,
  "79190", // AMBROSI 23,
  "79191", // AMBROSI 24,
  "79192", // AMBROSI 25,
  "79193", // AMBROSI 26,
  "79194", // AMBROSI 27,
  "79195", // AMBROSI 28,
  "79196", // AMBROSI 29,
  "79197", // AMBROSI 30,
  "79198", // Maria Eugenia 01,
  "79200", // CERTUS01,
  "79201", // LASTIRI 01,
  "79207", // Jaime 01,
  "79208", // Jaime 02,
  "79209", // Maldonado 01,
  "79213", // Maldonado 02,
  "79214", // Maldonado 03,
  "79220", // BALDERRAMA 01,
  "79230", // MACOOLEY 01,
  "79231", // MACOOLEY 02,
  "79232", // MACOOLEY 03,
  "79233", // MACOOLEY 04,
  "79234", // MACOOLEY 05,
  "79235", // MACOOLEY 06,
  "79236", // MACOOLEY 07,
  "79237", // MACOOLEY 08,
  "79238", // MACOOLEY 09,
  "79239", // MACOOLEY 10,
  "79241", // TyC Gestión de Negocios,
  "88100", // ROBERTO CHANDLER,
  "88101", // LOPEZ SEGURA 4,
  "88102", // ROLANDO CAMPILLO 2,
  "88103", // JAIME CH1,
  "88104", // JAIME CH2,
  "88105", // JAIME CH3,
  "88106", // JAIME CH4,
  "88107", // JAIME CH5,
  "88108", // Luis PR,
  "88109", // GRUPO CORISE 2,
  "88110", // SubAgente Viridiana Somarriba Zavala,
  "88111", // YAOPOL 02,
  "88112", // FAUDOA 01,
  "88113", // NAVA 01,
  "88114", // DIAZ 01,
  "88115", // MIRELES 05,
  "88116", // SILVA 08,
  "88117", // BITUAJ 01,
  "88118", // Castillejos 01,
  "88119", // Cequera 01,
  "88120", // Monge 01,
  "88121", // RED UNITAS AGENTE DE SEGUROS,
  "88122", // CERTUS 01,
  "88123", // Vallejos 01,
  "88124", // Vallejos 02,
  "88125", // UNITAS 01,
  "88126", // JAIME 01,
  "88127", // JULIAN 01,
  "88128", // Sergio Guerrero Garcia,
  "88129", // Hector Ochoa Zarate,
  "88130", // Dulce Martinez Armenta,
  "88131", // Juan Hernandez Roman,
  "88132", // Diana Morales Perez,
  "88133", // Aide Martinez Lima,
  "88134", // Alvaro Bencomo Renteria,
  "88135", // Leonardo Navarro Reyes,
  "88136", // Samuel Vera Ortega,
  "88137", // Maximiliano de Teresa Alonso,
  "88138", // Enrique Navarrete Solis,
  "88139", // Ivonne Martinez Sierra,
  "88140", // Francisco Esquivel Gamez,
  "88141", // Raul Cruz Gonzalez,
  "88142", // Karla Salazar Trejo,
  "88143", // Mayra Alejandra Rodriguez Barbosa,
  "88144", // Ahira Arroyo Dominguez,
  "88145", // Azucena Argüello Moran,
  "88146", // Leon Kibrit Faitelson,
  "88147", // Israel Pastora Salazar,
  "88148", // Israel Pastora Salazar,
  "88149", // Mireles 2,
  "88150", // BITUAJ 01,
  "88151", // Castro 01,
  "88152", // Saul 01,
  "88153", // Saul 02,
  "88154", // PELAEZ 01,
  "88155", // AGUILA 01,
  "88156", // AGUILA 02,
  "88157", // AGUILA 03,
  "88158", // AGUILA 04,
  "88159", // AGUILA 05,
  "88160", // AGUILA 06,
  "88161", // AGUILA 07,
  "88162", // AGUILA 08,
  "88163", // AGUILA 09,
  "88164", // PATRIM 01,
  "88165", // BITUAJ 01,
  "88166", // BITUAJ 02,
  "88167", // BITUAJ 03,
  "88168", // PROM387 01,
  "88171", // FEANGCAL ALTERNO,
  "88172", // UNITAS 01,
  "88173", // UNITAS 02,
  "88174", // UNITAS 03,
  "88175", // UNITAS 04,
  "88178", // MORA 01,
  "88179", // MORA 02,
  "88180", // MORA 03,
  "88181", // MORA 04,
  "88182", // MORA 05,
  "88183", // MORA 06,
  "88184", // MORA 07,
  "88185", // MORA 08,
  "88186", // MORA 09,
  "88187", // MORA 10,
  "88188", // MORA 11,
  "88189", // MORA 12,
  "88190", // MORA 13,
  "88191", // MORA 14,
  "88192", // MORA 15,
  "88193", // MORA 16,
  "88194", // MORA 17,
  "88195", // MORA 18,
  "88196", // MORA 19,
  "88197", // MORA 20,
  "88198", // MORA 21,
  "88199", // MORA 22,
  "88200", // MORA 23,
  "88201", // MORA 24,
  "88202", // MORA 25,
  "88203", // MORA 26,
  "88204", // MORA 27,
  "88205", // MORA 28,
  "88206", // MORA 29,
  "88207", // MORA 20,
  "88208", // MORA 31,
  "88209", // MORA 32,
  "88210", // Gabriela Palacios,
  "88211", // Patricia Jimenez,
  "88212", // Danae Martinez,
  "88213", // Luz del Carmen Flores,
  "88214", // Alberto Sanchez,
  "88215", // Salvador Martinez,
  "88216", // Mauricio Robles,
  "88217", // Mauricio Robles,
  "88218", // UNITAS UNO,
  "88219", // MANZANO UNO,
  "88220", // UNITAS 22,
  "88221", // LILIA1,
  "88222", // LILIA2,
  "88223", // LILIA3,
  "88224", // LILIA4,
  "88225", // LILIA6,
  "88226", // LILIA7,
  "88227", // LILIA8,
  "88228", // LILIA9,
  "88229", // LILIA10,
  "88230", // LILIA11,
  "88231", // LILIA12,
  "88232", // LILIA13,
  "88233", // LILIA14,
  "88234", // LILIA15,
  "88235", // LILIA16,
  "88236", // LILIA17,
  "88237", // LILIA18,
  "88238", // LILIA19,
  "88239", // LILIA20,
  "88240", // LILIA21,
  "88241", // LILIA22,
  "88242", // LILIA23,
  "88243", // LILIA24,
  "88244", // LILIA25,
  "88245", // LILIA5,
  "88246", // SUBAGENTE RED UNITAS,
  "88247", // SUBAGENTE RED UNITAS,
  "88248", // SUBAGENTE 3 RED UNITAS,
  "88249", // METRO 01,
  "88250", // METRO 02,
  "88251", // METRO 03,
  "88252", // METRO 04,
  "88253", // METRO 05,
  "88254", // METRO 06,
  "88255", // METRO 07,
  "88256", // REYDE 01,
  "88257", // REYDE 01,
  "88258", // GPLUS1,
  "88259", // PASTRANA UNO,
  "88260", // Luis Martin Avalos,
  "88261", // Jorge Alejandre Canales,
  "88262", // Elsa Torres Gomez,
  "88263", // Jacqueline Hurtado Garcia,
  "88264", // Diana Itzel Diaz Hernandez,
  "88265", // Jose Mauro Santillán Escamilla,
  "88266", // Esther Salcedo Campuzano,
  "88267", // CERTUS 01,
  "88268", // CERTUS 01
  "502", //NOHEMI MANZANO VALDEZ
  "901046", // JOSE ANTONIO MALDONADO
  "901066", // EMMANUEL ROMERO
  "901129", // BLANCA REYNA MORALES
  "901178", // DIANA VILLANUEVA
  "901443", // DULCE MEZA
  "901447", // OCTAVIO RIOJA
  "901448", // DANIELA MALENY ESPINOSA
  "901195", // OSCAR BETANCOURT
  "900721", // MOISES MONCADA
  "cobranza", // área de cobranza
  "9415", // 
  "77626", //
];